import { frontendURL } from '../../../../helper/URLHelper';
import { parseBoolean } from '@chatwoot/utils';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');
const MfaSettings = () => import('./MfaSettings.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/profile'),
      name: 'profile_settings',
      // advup: rota pai sem redirect renderizava vazia ao acessar /profile direto
      // (URL direta/hard-load). Redireciona pro filho padrão (settings).
      redirect: to => ({
        name: 'profile_settings_index',
        params: { accountId: to.params.accountId },
      }),
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: 'settings',
          name: 'profile_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
        {
          path: 'mfa',
          name: 'profile_settings_mfa',
          component: MfaSettings,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
          beforeEnter: (to, from, next) => {
            // Check if MFA is enabled globally
            if (!parseBoolean(window.chatwootConfig?.isMfaEnabled)) {
              // Redirect to profile settings if MFA is disabled.
              // 06/10/2026: sem `params`, aberta direto (link, recarga) a
              // rota de destino ficava sem `accountId`, a primeira
              // navegação falhava e o app nem montava — tela branca.
              next({ name: 'profile_settings_index', params: to.params });
            } else {
              next();
            }
          },
        },
      ],
    },
  ],
};
